import { useEffect } from "react";

export const useClickOutside = (excludeRef: any, onOutsideClick: any) => {
  const isOutsideClick = (ref: any, event: any) =>
    ref.current &&
    typeof ref.current.contains === "function" &&
    !ref.current.contains(event.target);

  const handleClickOutside = (event: any) => {
    if (Array.isArray(excludeRef)) {
      const result = excludeRef.map((r) => isOutsideClick(r, event));
      if (!result.includes(false)) {
        onOutsideClick();
      }
    } else if (isOutsideClick(excludeRef, event)) {
      onOutsideClick();
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  });
};
